module.exports = __webpack_public_path__ + "img/bsignup-continue-1@3x.5a911cce.png";